import { useSiteMetadata } from "../hooks/defaults/Use-SiteMetadata";

export const useReplaceDefaults = ({
	text,
	company,
	phone_number,
	area,
	service,
}) => {
	const { title, phoneNum, mainArea, mainService } = useSiteMetadata();
	const defaultNum = phone_number ? phone_number : phoneNum;
	const defaultService = service ? service : mainService;

	const defaultCompany = company ? company : title;
	const defaultArea = area ? area : mainArea;
	var replacedText = text;
	var replacedText = String(replacedText).replaceAll(
		"XXXCOMPANY",
		defaultCompany
	);
	var replacedText = String(replacedText).replaceAll("XXXPHONE", defaultNum);
	var replacedText = String(replacedText).replaceAll("XXXAREA", defaultArea);
	var replacedText = String(replacedText).replaceAll(
		"XXXMAINSERVICE",
		defaultService
	);

	return replacedText;
};
